import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  dateFieldContainer: {
    width: theme.spacing(36.375),
    marginTop: theme.spacing(2),
  },
  subHeading: {
    color: theme.palette.text.secondary,
    fontSize: '18px',
    fontWeight: 600,
    marginRight: theme.spacing(1.125),
  },
  infoIcon: {
    color: theme.palette.icon.main,
    marginTop: theme.spacing(0.75),
    '&.MuiSvgIcon-root': {
      height: '16px',
      width: '16px',
    },
  },
  textField: {
    width: '211px',
    marginRight: theme.spacing(3),
    '& .MuiInputBase-input': {
      fontSize: '13px',
      color: theme.palette.black.main,
      textAlign: 'left',
    },
    '& .MuiInputLabel-root': {
      fontSize: '13px',
      color: theme.palette.primary.light,
      fontWeight: 600,
    },
    '& .MuiFormHelperText-root.Mui-error': {
      fontSize: '11px',
    },
    '& .MuiFormLabel-asterisk.MuiInputLabel-asterisk': {
      color: theme.palette.requiredAsterisk.main,
    },
  },
  dateField: {
    '& .MuiInputLabel-root': {
      marginTop: theme.spacing(-0.5),
    },
  },
  expirationDateContainer: {
    display: 'flex',
    flexDirection: 'row',
  },
}))
